<template>
  <v-app>
    <progress-dialog ref="progressDialog"></progress-dialog>
    <alert-dialog ref="alertDialog"></alert-dialog>
    <error-dialog ref="errorDialog"></error-dialog>
    <modal-output-dialog ref="modalOutputDialog"></modal-output-dialog>

    <core-app-bar :exclusive="exclusive" />
    <core-drawer v-if="!exclusive" />
    <core-options-drawer />
    <core-view />
    <core-footer />
  </v-app>
</template>

<script>
import coreDrawer from "@/components/core/Drawer";
import coreFooter from "@/components/core/Footer";
import coreAppBar from "@/components/core/AppBar";
import coreView from "@/components/core/View";
import coreOptionsDrawer from "@/components/core/OptionsDrawer";
import appEvents from "@/app/events/events";
import { DevelopmentModeDetector } from "@/components/mixins/DevelopmentModeDetector";

export default {
  mixins: [DevelopmentModeDetector],
  components: {
    CoreDrawer: coreDrawer,
    CoreFooter: coreFooter,
    CoreAppBar: coreAppBar,
    CoreView: coreView,
    CoreOptionsDrawer: coreOptionsDrawer
  },
  computed: {
    exclusive() {
      // console.log(this.$route)
      // let x= this.$route.name == null || this.$route.meta.exclusive;
      // console.log(x)
      return this.$route.name === null || this.$route.meta.exclusive || this.exclusive_termbank;
    }
  },
  created() {
    window.getApp = this;

    // register events:
    appEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
  }
};
</script>
